// Styled Components
import styled from "styled-components";

const InfoFour = () => {
  return (
    <Wrapper>
      <div className="content">
        <p className="header">HERE IS WHERE THE GAME GETS INTERESTING...</p>
        <p className="info">
          When a player has generated 10+ Complete nfts, they are eligible to
          have one minted in real life by shoeuzi. This is a 1/1 marked and
          signed shoeuzi sculpture
        </p>
      </div>

      <div className="images">
        <div className="image">
          <img
            src="https://cdn.discordapp.com/attachments/896285560094748713/897899194306691142/Image_12.png"
            alt=""
          />
        </div>
        <div className="image">
          <img
            src="https://cdn.discordapp.com/attachments/896285560094748713/897899190376624138/Image_10.png"
            alt=""
          />
        </div>
        <div className="image">
          <img
            src="https://cdn.discordapp.com/attachments/896285560094748713/897899193732050975/Image_11.png"
            alt=""
          />
        </div>
      </div>
    </Wrapper>
  );
};

export default InfoFour;

const Wrapper = styled.div`
  width: 100%;
  padding: 0 20px;
  padding-top: 100px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .content {
    text-align: center;

    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .header {
      font-family: interstate, sans-serif;
      font-weight: 900;
      font-style: normal;
      font-size: 2rem;

      font-family: "Pixeltype";
      font-weight: 200;
      line-height: 48px;

      //
      width: 520px;
      @media only screen and (max-width: 550px) {
        width: 100%;
      }
      //
    }

    .info {
      //
      width: 720px;
      @media only screen and (max-width: 750px) {
        width: 100%;
      }
      //

      color: #8f8f8f;
      font-size: 1.2rem;
      padding-top: 30px;

      line-height: 31px;

      color: #fff;
      font-family: "Open Sans", sans-serif;
      font-weight: 300;
    }
  }

  .images {
    //
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    @media only screen and (max-width: 1225px) {
      flex-direction: column;
    }
    //

    .image {
      margin-top: 30px;
      width: 350px;
      background-color: blue;

      height: 400px;
      object-fit: cover;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
`;
